import { createContext as e } from "react";
import { YandexMetrics as r } from "./chunk360.js";
import { createQueryClient as o, createIDBPersister as t } from "./chunk328.js";
import { QueryClientProvider as c } from "./chunk361.js";
import { AppConfigContext as L, AppConfigProvider as P, appConfig as g } from "./chunk362.js";
import { MainLoaderStore as u, hideLoader as y, mainLoaderStore as M, showLoader as h } from "./chunk363.js";
const p = o(), s = t(), m = e({}), d = new r();
export {
  L as AppConfigContext,
  P as AppConfigProvider,
  u as MainLoaderStore,
  c as QueryClientProvider,
  m as UserDataContext,
  d as YM,
  g as appConfig,
  y as hideLoader,
  s as idbPersister,
  M as mainLoaderStore,
  p as queryClient,
  h as showLoader
};
